export class SelectableData {
	public constructor(public readonly outputKey: string, public readonly matchString: string) {}
}

export const selectableDataFromItems = <TItem>(
	items: readonly TItem[],
	mapOutputKey: (i: TItem) => string,
	mapMatchString: (i: TItem) => string
): readonly SelectableData[] => {
	return items.map((i) => selectableDataFrom(i, mapOutputKey, mapMatchString));
};

export const selectableDataFrom = <TItem>(
	item: TItem,
	mapOutputKey: (i: TItem) => string,
	mapMatchString: (i: TItem) => string
): SelectableData => {
	return selectableData(mapOutputKey(item), mapMatchString(item));
};

export const selectableData = (outputKey: string, matchString: string): SelectableData => {
	return { outputKey, matchString };
};
